module.exports = __webpack_public_path__ + "img/part-1-info-1.080be187.png";